var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicSlash = function SvgMicSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.372 20.95a7.913 7.913 0 0 0 3.642 1.327v2.1h-2.605a.82.82 0 0 0-.83.812c0 .45.374.811.83.811h6.874a.82.82 0 0 0 .83-.811.821.821 0 0 0-.83-.811h-2.605v-2.1c3.94-.409 7.014-3.672 7.014-7.624v-3.197a.826.826 0 0 0-.834-.816.82.82 0 0 0-.83.81v3.198c0 3.334-2.773 6.044-6.184 6.044a6.249 6.249 0 0 1-3.288-.927l-1.184 1.183Zm2.182-2.182c.68.363 1.46.57 2.29.57 2.643 0 4.797-2.115 4.797-4.717v-2.94l-1.664 1.664v1.28c0 1.703-1.406 3.09-3.133 3.09-.371 0-.728-.063-1.058-.18l-1.232 1.233Zm-.773-3.47-1.3 1.3a4.58 4.58 0 0 1-.435-1.944V6.688C9.046 4.1 11.2 2 13.844 2c2.648 0 4.797 2.105 4.797 4.688v.75l-1.664 1.664V6.688c0-1.687-1.406-3.061-3.133-3.061S10.71 5 10.71 6.688v7.966c0 .22.024.436.07.644Zm-2.32 2.32-1.2 1.2A7.496 7.496 0 0 1 6 14.654v-3.197c0-.45.379-.812.835-.812.455 0 .83.361.83.812v3.197a5.9 5.9 0 0 0 .796 2.964Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22 23 4",
    stroke: "#fff",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
};
export default SvgMicSlash;